"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.setAudioRecordingManager = setAudioRecordingManager;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _models = require("@seedlang/models");
var _utils = require("@seedlang/utils");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _bowser = _interopRequireDefault(require("bowser"));
var _audio_recorder_store = _interopRequireDefault(require("./audio_recorder_store"));
var _video_recorder_store = _interopRequireDefault(require("./video_recorder_store"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24;
var MAX_AUDIO_LEVEL = 100;
var LEVEL_MULTIPLIER = 230;

// AudioRecordingManager will be injected for native environments
var AudioRecordingManager = null;

// Method to inject AudioRecordingManager for native environments
function setAudioRecordingManager(manager) {
  AudioRecordingManager = manager;
}
var MediaStore = (_class = /*#__PURE__*/function () {
  function MediaStore() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, MediaStore);
    (0, _initializerDefineProperty2["default"])(this, "audioStreamInstantiated", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "mediaType", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "objectUrl", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "isRecording", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "audioLevel", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "maxAudioLevel", _descriptor6, this);
    (0, _initializerDefineProperty2["default"])(this, "data", _descriptor7, this);
    (0, _initializerDefineProperty2["default"])(this, "stream", _descriptor8, this);
    (0, _initializerDefineProperty2["default"])(this, "secondsElapsed", _descriptor9, this);
    (0, _initializerDefineProperty2["default"])(this, "startRecordingTimestamp", _descriptor10, this);
    (0, _initializerDefineProperty2["default"])(this, "endRecordingTimestamp", _descriptor11, this);
    (0, _initializerDefineProperty2["default"])(this, "startPlayingTimestamp", _descriptor12, this);
    (0, _initializerDefineProperty2["default"])(this, "pausePlayingTimestamp", _descriptor13, this);
    (0, _initializerDefineProperty2["default"])(this, "playing", _descriptor14, this);
    (0, _initializerDefineProperty2["default"])(this, "initialPlayHasFinished", _descriptor15, this);
    (0, _initializerDefineProperty2["default"])(this, "currentTime", _descriptor16, this);
    (0, _initializerDefineProperty2["default"])(this, "url", _descriptor17, this);
    (0, _initializerDefineProperty2["default"])(this, "durationFromDatabase", _descriptor18, this);
    (0, _initializerDefineProperty2["default"])(this, "isNative", _descriptor19, this);
    (0, _initializerDefineProperty2["default"])(this, "hasNativeSound", _descriptor20, this);
    (0, _initializerDefineProperty2["default"])(this, "canRecord", _descriptor21, this);
    (0, _initializerDefineProperty2["default"])(this, "nativeSoundIsLoading", _descriptor22, this);
    (0, _initializerDefineProperty2["default"])(this, "autoPlay", _descriptor23, this);
    (0, _initializerDefineProperty2["default"])(this, "hasFinishedRecording", _descriptor24, this);
    // Add flag to prevent multiple rapid onReset calls
    this._isResetting = false;
    this._resetTimeout = null;
    this.streams = [];
    this.isNative = params.isNative;
    this.parent = params.parent;
    this.cardId = params.cardId;
    // Audio setup will be initialized when card becomes active

    // Create scoped logger for native environments
    if (this.isNative) {
      // Import logger dynamically for native environment
      try {
        var logger = require('../../../mobile/mobile/utils/logger')["default"];
        this.logger = logger.createScoped('MediaStore');
        // Import AppUI to check logging flag
        var _require = require('@seedlang/state'),
          AppUI = _require.AppUI;
        this.AppUI = AppUI;
      } catch (e) {
        // Fallback if logger not available
        this.logger = null;
        this.AppUI = null;
      }
    }
  }

  // Helper method to check if logging should be enabled
  return (0, _createClass2["default"])(MediaStore, [{
    key: "shouldLog",
    value: function shouldLog() {
      // Check the ENABLE_MOBILE_LOGGING flag from AppUI
      return this.AppUI && this.AppUI.ENABLE_MOBILE_LOGGING === true;
    }
  }, {
    key: "normalizedAudioLevel",
    get: function get() {
      var level = Math.round(this.audioLevel * LEVEL_MULTIPLIER);
      if (level > MAX_AUDIO_LEVEL) {
        level = MAX_AUDIO_LEVEL;
      }
      return level;
    }
  }, {
    key: "duration",
    get: function get() {
      if (this.durationFromDatabase) {
        return this.durationFromDatabase;
      }
      if (this.endRecordingTimestamp && this.startRecordingTimestamp && this.endRecordingTimestamp > 0 && this.startRecordingTimestamp > 0) {
        return Math.round((this.endRecordingTimestamp - this.startRecordingTimestamp) / 1000 * 10) / 10;
      }
      return null;
    }
  }, {
    key: "hasUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.url);
    }
  }, {
    key: "durationString",
    get: function get() {
      return "".concat(this.duration, "s");
    }
  }, {
    key: "hasObjectUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.objectUrl);
    }
  }, {
    key: "hasRecording",
    get: function get() {
      return (0, _utils.isPresent)(this.data);
    }
  }, {
    key: "set",
    value: function set(obs, value) {
      this[obs] = value;
    }
  }, {
    key: "initializeAudioIfNeeded",
    value: function initializeAudioIfNeeded() {
      // Initialize audio for current card when it becomes active
      if (!this.isNative && !this.audioStreamInstantiated && !this.mediaType) {
        this.setupAudio();
        if (!this.audioStream) {
          this.audioStream = new _models.AudioStream();
        }
      }
    }
  }, {
    key: "timeDisplay",
    get: function get() {
      var divisorMinutes = this.secondsElapsed % (60 * 60);
      var minutes = Math.floor(divisorMinutes / 60);
      var divisorSeconds = divisorMinutes % 60;
      var seconds = Math.ceil(divisorSeconds);
      return "".concat(minutes < 10 ? 0 : '').concat(minutes, ":").concat(seconds < 10 ? 0 : '').concat(seconds);
    }
  }, {
    key: "setNativeAudioRecorder",
    value: function setNativeAudioRecorder(nativeAudioRecorder) {
      this.nativeAudioRecorder = nativeAudioRecorder;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      // Clear recording lock if we're disposing while recording
      if (this.isNative && AudioRecordingManager && this.cardId && this.isRecording) {
        AudioRecordingManager.stopRecording(this.cardId);
      }
      this.stopSecondsElapsed();

      // Clean up audio resources if they exist
      if (!this.isNative) {
        this.clearAudioStream();
      }

      // Clear recorder reference
      if (this.recorder) {
        this.recorder = null;
      }
    }
  }, {
    key: "startSecondsElapsed",
    value: function startSecondsElapsed() {
      var _this = this;
      this.startRecordingTimestamp = +new Date();
      this.interval = setInterval(function () {
        return _this.secondsElapsed += 1;
      }, 1000);
    }
  }, {
    key: "stopSecondsElapsed",
    value: function stopSecondsElapsed() {
      this.endRecordingTimestamp = +new Date();
      clearInterval(this.interval);
    }
  }, {
    key: "recordAudio",
    value: function recordAudio() {
      if (this.mediaType === 'audio') {
        this.startRecording();
      } else {
        this.setupAudio(this.record);
      }
    }
  }, {
    key: "setupVideo",
    value: function setupVideo(params, callback) {
      if (!this.isNative && this.mediaType !== 'video' || this.afterDeviceGrantedAccess !== callback) {
        this.mediaType = 'video';
        this.getUserMediaWithCallback(params, callback);
      }
    }
  }, {
    key: "setupAudio",
    value: function setupAudio(callback) {
      if (!this.isNative && this.mediaType !== 'audio') {
        this.getUserMediaWithCallback({
          audio: true,
          video: false
        }, callback);
        this.mediaType = 'audio';
      }
    }
  }, {
    key: "getUserMediaWithCallback",
    value: function getUserMediaWithCallback(params, callback) {
      if (callback) {
        this.afterDeviceGrantedAccess = callback;
      }
      if (!this.isNative && !_bowser["default"].ios && !_bowser["default"].safari) {
        (0, _utils.getUserMedia)(params, this.onDeviceGrantedAccess, this.onDeviceDeniedAccess);
      }
    }
  }, {
    key: "onDeviceGrantedAccess",
    value: function onDeviceGrantedAccess(stream) {
      this.streams.push(stream);
      this.stream = stream;
      this.setupRecorder();
      if ((0, _lodash.isFunction)(this.afterDeviceGrantedAccess)) {
        this.afterDeviceGrantedAccess(stream);
      }
    }
  }, {
    key: "setupRecorder",
    value: function setupRecorder() {
      if (this.parent && !this.parent.deviceDeniedAccess) {
        if (!this.audioStreamInstantiated) {
          this.audioStreamInstantiated = true;
          // Lazy initialize AudioStream if not already created
          if (!this.audioStream && !this.isNative) {
            this.audioStream = new _models.AudioStream();
          }
          if (this.audioStream) {
            this.audioStream.onStreamSuccess(this.stream, this.onAudioLevelUpdate);
          }
        }
        if (this.mediaType === 'video') {
          this.recorder = new _video_recorder_store["default"](this.stream, this.onHandleData);
        } else if (this.mediaType === 'audio') {
          this.recorder = new _audio_recorder_store["default"](this.stream, this.onHandleData);
        }
      }
    }
  }, {
    key: "clearVideoStream",
    value: function clearVideoStream() {
      (0, _lodash.each)(this.streams, function (stream) {
        stream.getTracks().forEach(function (track) {
          if (track.kind === 'video') {
            track.stop();
          }
        });
      });
      this.streams = [];
      this.stream = null; // Nullify the current stream reference
    }
  }, {
    key: "clearAudioStream",
    value: function clearAudioStream() {
      if (this.audioStream) {
        this.audioStream.cleanup();
        this.audioStream = null; // Nullify reference to allow garbage collection
      }
      this.mediaType = null;
      this.audioStreamInstantiated = false;
      (0, _lodash.each)(this.streams, function (stream) {
        stream.getTracks().forEach(function (track) {
          if (track.kind === 'audio') {
            track.stop();
          }
        });
      });
      this.streams = []; // Clear the array
      this.stream = null; // Nullify the current stream reference
    }
  }, {
    key: "onHandleData",
    value: function onHandleData(e) {
      if (this.isRecording && e.data && e.data.size > 0) {
        this.data.push(e.data);
      }
    }
  }, {
    key: "onAudioLevelUpdate",
    value: function onAudioLevelUpdate(audioLevel) {
      this.audioLevel = audioLevel;
      if (this.normalizedAudioLevel > this.maxAudioLevel) {
        this.maxAudioLevel = this.normalizedAudioLevel;
      }
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      // Only check with AudioRecordingManager on native platforms
      if (this.isNative && AudioRecordingManager && this.cardId) {
        // Check if this card is the current visible card
        var isCurrentCard = this.parent && this.parent.currentCard && this.parent.currentCard.id === this.cardId;
        if (!isCurrentCard) {
          // console.warn(`[MediaStore] Cannot start recording on card ${this.cardId} - not the current visible card`);
          return;
        }
        if (!AudioRecordingManager.canRecord(this.cardId)) {
          // console.warn(`[MediaStore] Cannot start recording on card ${this.cardId} - another recording is in progress`);
          return;
        }
        if (!AudioRecordingManager.startRecording(this.cardId)) {
          // console.warn(`[MediaStore] Failed to acquire recording lock for card ${this.cardId}`);
          return;
        }
      }
      if (this.isNative || this.recorder) {
        this.onSoftReset();
        this.startSecondsElapsed();
        this.startRecordingTimestamp = +new Date();
        this.isRecording = true;
      }
      if (this.isNative && this.nativeAudioRecorder) {
        this.nativeAudioRecorder.startRecording({
          callback: this.updateScreenForRecordingStatus,
          audioPlaybackFinishedCallback: this.audioPlaybackFinishedCallback
        });
      } else if (this.recorder) {
        if (this.audioStream) {
          this.audioStream.startMonitor();
        }
        this.recorder.record();
      }
    }
  }, {
    key: "audioPlaybackFinishedCallback",
    value: function audioPlaybackFinishedCallback() {
      this.playing = false;
      this.pausePlayingTimestamp = +new Date();
      clearInterval(this.interval);
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.autoPlay = params.autoPlay;
      if (!this.isRecording) {
        return;
      }

      // Only log if mobile logging is enabled
      if (this.isNative && this.shouldLog()) {
        console.log('[MediaStore] stopRecording called', {
          cardId: this.cardId,
          autoPlay: params.autoPlay,
          skipCallback: params.skipCallback
        });
      }

      // Release recording lock with AudioRecordingManager on native
      if (this.isNative && AudioRecordingManager && this.cardId) {
        if (!AudioRecordingManager.stopRecording(this.cardId)) {
          // console.warn(`[MediaStore] Failed to release recording lock for card ${this.cardId}`);
        }
      }
      if (this.isNative || this.recorder) {
        this.stopSecondsElapsed();
        this.audioLevel = 0;
        this.endRecordingTimestamp = +new Date();
        this.isRecording = false;
        this.hasFinishedRecording = true;
      }
      if (this.isNative) {
        if (!params.skipCallback) {
          this.nativeSoundIsLoading = true;
        }
        if (this.nativeAudioRecorder) {
          if (this.shouldLog()) {
            console.log('[MediaStore] Calling nativeAudioRecorder.stopRecording');
          }
          this.nativeAudioRecorder.stopRecording({
            callback: this.updateScreenForSoundStatus,
            cardId: this.cardId
          });
        }
      } else if (this.recorder) {
        if (this.audioStream) {
          this.audioStream.stopMonitor();
        }
        this.recorder.stop();
        if (!params.skipCreateObjectURL && (0, _utils.isPresent)(this.data)) {
          this.objectUrl = this.createObjectURL(this.createBlob());
        }
      }
      // EventStore.create({data: {eventType: 'deck - finish recording', params: {duration_in_seconds: this.duration}}}, () => {});
    }
  }, {
    key: "updateScreenForRecordingStatus",
    value: function updateScreenForRecordingStatus(status) {
      this.canRecord = status.canRecord;
      if (status.metering) {
        var linearAudioLevel = Math.pow(10, status.metering / 20) * 160;
        this.onAudioLevelUpdate(linearAudioLevel / LEVEL_MULTIPLIER);
      }
      if ((status.isDoneRecording || status.isRecording) && status.durationMillis) {
        this.durationFromDatabase = Math.round(status.durationMillis / 1000 * 10) / 10;
      }
    }
  }, {
    key: "updateScreenForSoundStatus",
    value: function updateScreenForSoundStatus(status) {
      var _this2 = this;
      if (this.shouldLog()) {
        console.log('[MediaStore] updateScreenForSoundStatus called', {
          cardId: this.cardId,
          status: status,
          hasNativeSound: this.hasNativeSound,
          autoPlay: this.autoPlay,
          playing: this.playing
        });
      }
      if (this.playing && status.didJustFinish) {
        this.playing = false;
        this.pausePlayingTimestamp = +new Date();
        clearInterval(this.interval);
        if (this.shouldLog()) {
          console.log('[MediaStore] Playback finished');
        }
      } else if (!this.hasNativeSound && status.isLoaded) {
        if (this.shouldLog()) {
          console.log('[MediaStore] Recording loaded, setting hasNativeSound = true');
        }
        this.nativeAudioRecorder.setCanPlay(true);
        this.hasNativeSound = true;
        this.nativeSoundIsLoading = false;
        if (this.autoPlay && this.nativeAudioRecorder) {
          if (this.shouldLog()) {
            console.log('[MediaStore] AutoPlay enabled, playing in 100ms');
          }
          // Use a moderate delay that works for both platforms
          setTimeout(function () {
            return _this2.play();
          }, 100);
        }
      }
    }
  }, {
    key: "createObjectURL",
    value: function createObjectURL(file) {
      if (window.webkitURL) {
        return window.webkitURL.createObjectURL(file);
      }
      if (window.URL && window.URL.createObjectURL) {
        return window.URL.createObjectURL(file);
      }
      return null;
    }
  }, {
    key: "onSoftReset",
    value: function onSoftReset() {
      if (this.logger) {
        this.logger.log('onSoftReset called for cardId:', this.cardId);
      }
      // Don't call native audio recorder reset here - it's a singleton shared across all cards
      // The AudioRecorder manages its own lifecycle and calling reset here disrupts
      // audio sessions during card transitions
      this.audioStreamInstantiated = false;
      this.isRecording = false;
      this.audioLevel = 0;
      this.maxAudioLevel = 0;
      this.durationFromDatabase = this.isNative ? null : this.durationFromDatabase;
      this.startRecordingTimestamp = null;
      this.endRecordingTimestamp = null;
      this.startPlayingTimestamp = null;
      this.pausePlayingTimestamp = null;
      this.data = [];
      this.objectUrl = null;
      this.secondsElapsed = 0;
      this.hasNativeSound = false;
      this.hasFinishedRecording = false;
    }
  }, {
    key: "onReset",
    value: function onReset() {
      var _this3 = this;
      if (this.logger) {
        // Log the call without creating an Error object that shows in console
        this.logger.log('onReset called for cardId:', this.cardId);
      }
      // Debounce rapid successive onReset calls
      if (this._resetTimeout) {
        clearTimeout(this._resetTimeout);
      }

      // If already resetting, just schedule for later
      if (this._isResetting) {
        if (this.logger) {
          this.logger.log('onReset already in progress, scheduling for later');
        }
        this._resetTimeout = setTimeout(function () {
          return _this3.onReset();
        }, 50);
        return;
      }
      this._isResetting = true;
      try {
        // Clear recording lock if we're resetting while recording
        if (this.isNative && AudioRecordingManager && this.cardId && this.isRecording) {
          AudioRecordingManager.stopRecording(this.cardId);
        }
        if (this.audio) {
          this.audio.src = '';
        }
        this.pause();
        this.playing = false;
        this.currentTime = 0;
        this.initialPlayHasFinished = false;
        this.onSoftReset();
      } finally {
        // Reset the flag after a small delay to handle any immediate follow-up calls
        setTimeout(function () {
          _this3._isResetting = false;
        }, 10);
      }
    }
  }, {
    key: "cleanupOffscreen",
    value: function cleanupOffscreen() {
      if (this.isRecording) {
        this.stopRecording({
          skipCallback: true
        });
      }
      if (!this.isNative) {
        this.clearAudioStream();
      }
      if (this.data && this.data.length > 0) {
        this.data = [];
      }
      if (this.objectUrl && typeof window !== 'undefined' && window.URL && window.URL.revokeObjectURL) {
        window.URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
      }
      this.onSoftReset();
    }
  }, {
    key: "resetForNewRecording",
    value: function resetForNewRecording() {
      if (this.logger) {
        this.logger.log('resetForNewRecording called for cardId:', this.cardId);
      }

      // Step 1: Cleanup existing recording state and resources
      this.cleanupOffscreen();

      // Step 2: Reinitialize audio system for new recording
      this.initializeAudioIfNeeded();

      // Step 3: Reset native recorder to get fresh instance with new URI
      if (this.isNative && this.nativeAudioRecorder) {
        // Force the AudioRecorder to create a new recorder instance
        if (this.nativeAudioRecorder.onReset) {
          try {
            this.nativeAudioRecorder.onReset();
          } catch (error) {
            if (this.logger) {
              this.logger.log('Error calling nativeAudioRecorder.onReset during fresh recording reset:', error);
            }
          }
        }
        // Reconnect to ensure we get fresh recorder instance with new URI
        this.setNativeAudioRecorder(this.nativeAudioRecorder);
      }
    }
  }, {
    key: "onDeviceDeniedAccess",
    value: function onDeviceDeniedAccess() {
      if (this.parent) {
        this.parent.set('deviceDeniedAccess', true);
      }
    }
  }, {
    key: "getFormData",
    value: function getFormData() {
      var formData = new FormData();
      formData.append('blob', this.createBlob());
      return formData;
    }
  }, {
    key: "createBlob",
    value: function createBlob() {
      return this.recorder.createBlob(this.data);
    }
  }, {
    key: "setupAudioPlayer",
    value: function setupAudioPlayer(audioEl, url, duration) {
      this.durationFromDatabase = duration;
      this.audio = audioEl;
      if (this.hasRecording) {
        this.setUrl(this.objectUrl);
      } else if (url) {
        this.setUrl(url);
      }
    }
  }, {
    key: "setUrl",
    value: function setUrl(url) {
      if (this.audio) {
        this.url = url;
        this.audio.src = url;
        this.audio.addEventListener('ended', this.onEnd.bind(this));
      }
    }
  }, {
    key: "onTogglePlay",
    value: function onTogglePlay() {
      this.playing ? this.pause() : this.play();
    }
  }, {
    key: "play",
    value: function play() {
      var _this4 = this;
      if (this.shouldLog()) {
        var _this$nativeAudioReco;
        console.log('[MediaStore] play() called', {
          isNative: this.isNative,
          hasNativeSound: this.hasNativeSound,
          hasRecording: this.hasRecording,
          hasUrl: this.hasUrl,
          url: this.url,
          cardId: this.cardId,
          nativeAudioRecorder: !!this.nativeAudioRecorder,
          canPlay: (_this$nativeAudioReco = this.nativeAudioRecorder) === null || _this$nativeAudioReco === void 0 ? void 0 : _this$nativeAudioReco.canPlay
        });
      }
      if (this.logger) {
        this.logger.log('play() called', {
          isNative: this.isNative,
          hasNativeSound: this.hasNativeSound,
          hasRecording: this.hasRecording,
          hasUrl: this.hasUrl,
          url: this.url,
          cardId: this.cardId,
          nativeAudioRecorder: !!this.nativeAudioRecorder
        });
      }
      if (this.isNative) {
        this.playing = true;
        this.startPlayingTimestamp = +new Date();
        if (this.hasNativeSound && this.nativeAudioRecorder) {
          if (this.shouldLog()) {
            console.log('[MediaStore] Playing via nativeAudioRecorder.play()');
          }
          if (this.logger) {
            this.logger.log('Playing via nativeAudioRecorder');
          }
          this.nativeAudioRecorder.play();
        } else {
          if (this.shouldLog()) {
            console.log('[MediaStore] Cannot play - missing requirements', {
              hasNativeSound: this.hasNativeSound,
              nativeAudioRecorder: !!this.nativeAudioRecorder
            });
          }
          if (this.logger) {
            this.logger.log('Cannot play - no nativeSound or nativeAudioRecorder');
          }
        }
      } else if (this.audio && (this.hasRecording || this.hasUrl)) {
        var promise = this.audio.play();
        if (promise !== undefined) {
          promise.then(function () {
            _this4.playing = true;
            _this4.startPlayingTimestamp = +new Date();
            clearInterval(_this4.interval);
            _this4.interval = setInterval(_this4.updateTimer.bind(_this4), 10);
          })["catch"](function (error) {
            // Sentry.captureException(error);
            throw error;
          });
        }
      }
    }
  }, {
    key: "updateTimer",
    value: function updateTimer() {
      this.currentTime = this.audio.currentTime;
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!this.playing) {
        return;
      }
      if (this.isNative || this.audio) {
        this.playing = false;
        this.pausePlayingTimestamp = +new Date();
        clearInterval(this.interval);
      }
      if (this.isNative && this.nativeAudioRecorder) {
        this.nativeAudioRecorder.pause();
      } else if (this.audio) {
        this.audio.pause();
      }
    }
  }, {
    key: "onEnd",
    value: function onEnd() {
      clearInterval(this.interval);
      this.currentTime = 0;
      this.playing = false;
      this.initialPlayHasFinished = true;
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioStreamInstantiated", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "mediaType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "objectUrl", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isRecording", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "maxAudioLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stream", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "secondsElapsed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startRecordingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "endRecordingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startPlayingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pausePlayingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "playing", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "initialPlayHasFinished", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "currentTime", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor17 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "url", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "durationFromDatabase", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isNative", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasNativeSound", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "canRecord", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor22 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "nativeSoundIsLoading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "autoPlay", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasFinishedRecording", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "normalizedAudioLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "normalizedAudioLevel"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "duration", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "duration"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUrl"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "durationString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "durationString"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasObjectUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasObjectUrl"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasRecording", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "set", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "initializeAudioIfNeeded", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "initializeAudioIfNeeded"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "timeDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeDisplay"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setNativeAudioRecorder", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeAudioRecorder"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "dispose", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "dispose"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startSecondsElapsed", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "startSecondsElapsed"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stopSecondsElapsed", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "stopSecondsElapsed"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "recordAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "recordAudio"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setupVideo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setupVideo"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setupAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setupAudio"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "getUserMediaWithCallback", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getUserMediaWithCallback"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onDeviceGrantedAccess", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onDeviceGrantedAccess"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setupRecorder", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setupRecorder"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "clearVideoStream", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearVideoStream"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "clearAudioStream", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearAudioStream"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onHandleData", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onHandleData"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onAudioLevelUpdate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onAudioLevelUpdate"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startRecording", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "startRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioPlaybackFinishedCallback", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "audioPlaybackFinishedCallback"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stopRecording", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "stopRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "updateScreenForRecordingStatus", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateScreenForRecordingStatus"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "updateScreenForSoundStatus", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateScreenForSoundStatus"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "createObjectURL", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "createObjectURL"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onSoftReset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSoftReset"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onReset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onReset"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "cleanupOffscreen", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "cleanupOffscreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "resetForNewRecording", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "resetForNewRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onDeviceDeniedAccess", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onDeviceDeniedAccess"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "getFormData", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getFormData"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "createBlob", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "createBlob"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setupAudioPlayer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setupAudioPlayer"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setUrl", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setUrl"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onTogglePlay", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onTogglePlay"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "play", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "play"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "updateTimer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateTimer"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pause", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "pause"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onEnd", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onEnd"), _class.prototype), _class);
var _default = exports["default"] = MediaStore;